export default "__VITE_ASSET__CE_SU67l__"